<div>
	<div fxLayout="column" fxFill fxLayoutAlign="flex-end flex-end">
		<button mat-icon-button (click)="onCloseClick()">
			<img
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/crossBlack/public"
			/>
		</button>
	</div>

	<div fxLayout="column" fxFill>
		<!-- First Column -->

		<!-- Row for heading -->
		<div
			fxLayout="column wrap"
			fxLayoutAlign="space-between"
			fxFill
			ngClass="p-l-l p-r-l"
		>
			<h2 i18n="@@shared_thankDonar_sendMessage_heading">Send Message</h2>
			<h4 i18n="@@shared_thankDonar_message_note">
				Note: this message is visible to everyone.
			</h4>
		</div>
		<mat-dialog-content fxLayout="column">
			<!-- Row For Text-Area -->
			<mat-form-field appearance="outline" fxFill ngClass="p-b-xs">
				<textarea
					i18n="@@shared_thankDonar_replyText_form"
					rows="9"
					maxlength="200"
					matInput
					#input
					required
					placeholder="{{ this.replyMessage }}"
					[formControl]="replyForm"
				></textarea>
				<mat-hint align="end">{{ input.value.length || 0 }}/200</mat-hint>
			</mat-form-field>
			<!-- Row For Button -->
			<div
				fxLayout="column-reverse"
				fxLayoutAlign="flex-end flex-end"
				*ngIf="this.updateButtonCheck"
				ngClass="p-b-s"
			>
				<button
					i18n="@@button_sendMessage_label"
					mat-flat-button
					color="accent"
					[disabled]="replyForm.invalid"
					(click)="postReply(input.value)"
				>
					Send Message
				</button>
			</div>

			<div
				fxLayout="row"
				fxLayoutAlign="end center"
				*ngIf="!this.updateButtonCheck"
				ngClass="p-b-s"
			>
				<button
					i18n="@@button_update"
					mat-flat-button
					color="accent"
					fxFlex="60%"
					[disabled]="replyForm.invalid"
					(click)="postReply(input.value)"
				>
					Update Message
				</button>
			</div>
		</mat-dialog-content>
	</div>
</div>
